import styled from 'styled-components';

export const I = styled.i`
  display: block;
`;
